<template>
  <svg @click="share" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{ title }}</title>
    <path :fill="color"
          d="M24,0C10.7,0,0,10.7,0,24c0,10.2,6.3,18.9,15.3,22.3c-0.2-1.9-0.4-4.8,0.1-6.9c0.4-1.9,2.8-11.9,2.8-11.9 s-0.7-1.4-0.7-3.6c0-3.3,1.9-5.8,4.3-5.8c2,0,3,1.5,3,3.4c0,2.1-1.3,5.1-2,8c-0.6,2.4,1.2,4.3,3.6,4.3c4.3,0,7.5-4.5,7.5-11 c0-5.7-4.1-9.8-10-9.8c-6.8,0-10.8,5.1-10.8,10.4c0,2.1,0.8,4.3,1.8,5.5c0.2,0.2,0.2,0.4,0.2,0.7c-0.2,0.8-0.6,2.4-0.7,2.7 c-0.1,0.4-0.3,0.5-0.8,0.3c-3-1.4-4.9-5.8-4.9-9.3c0-7.6,5.5-14.5,15.9-14.5c8.3,0,14.8,5.9,14.8,13.9c0,8.3-5.2,14.9-12.5,14.9 c-2.4,0-4.7-1.3-5.5-2.8c0,0-1.2,4.6-1.5,5.7c-0.5,2.1-2,4.7-3,6.3c2.2,0.7,4.6,1.1,7.1,1.1c13.3,0,24-10.7,24-24 C48,10.7,37.3,0,24,0z"></path>
  </svg>
</template>

<script>
export default {
  name: "Pinterest",
  props: {
    title: {
      type: String,
      default: "Partager sur Pinterest"
    },
    size: {
      type: Number,
      default: 32,
    },
    color: {
      default: '#003d57',
    },
  },
  data() {
    return {}
  },
  methods: {
    share() {
      const title = document.head.querySelector('title')
      this.$window.open(`https://www.pinterest.com/pin/create/button/?canonicalUrl=${encodeURIComponent('https://www.go2roues.com/actualites/askoll-ngs/')}`)
    },
  },
}
</script>

<style scoped lang="scss">

</style>

